// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './translate/langs/en.json';
import chtTranslations from './translate/langs/cht.json';
import chsTranslations from './translate/langs/chs.json';
import koTranslations from './translate/langs/ko.json';
import jpTranslations from './translate/langs/jp.json';
import itTranslations from './translate/langs/it.json';
import frTranslations from './translate/langs/fr.json';
import deTranslations from './translate/langs/de.json';
import esTranslations from './translate/langs/es.json';
import ruTranslations from './translate/langs/ru.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  it: {
    translation: itTranslations,
  },
  jp: {
    translation: jpTranslations,
  },
  cht: {
    translation: chtTranslations,
  },
  chs: {
    translation: chsTranslations,
  },
  ko: {
    translation: koTranslations,
  },
  fr: {
    translation: frTranslations,
  },
  de: {
    translation: deTranslations,
  },
  es: {
    translation: esTranslations,
  },
  ru: {
    translation: ruTranslations,
  }
};

// Get saved language or default to 'en'
const savedLanguage = localStorage.getItem('selectedLanguage');
const defaultLanguage = savedLanguage && resources[savedLanguage] ? savedLanguage : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'en',
    debug: false,
    keySeparator: false,
    nsSeparator: false,
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
      format: function (value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      },
    },
  });

// Listen for language changes and update localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('selectedLanguage', lng);
});

export default i18n;

